import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { AgencyBillingClosureService } from "../../../service/AgencyBillingClosureService";

class UpdateAgencyBillingClosureValuesStore {

    public agencyBillingClosureId: string;
    public totalAmount: number;
    public notes?: string;
    public isEditing: boolean;
    public isModalOpen: boolean;
    public loading: boolean;

    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, agencyBillingClosureId: string, totalAmount: number, notes?: string) {
        this.isEditing = !!agencyBillingClosureId;
        this.agencyBillingClosureId = agencyBillingClosureId;
        this.isModalOpen = false;
        this.totalAmount = totalAmount;
        this.notes = notes;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async save(): Promise<boolean> {
        this.loading = true;
        const response = await AgencyBillingClosureService.update(this.agencyBillingClosureId, this.totalAmount, this.notes || '');
        this.commonStore.processErrors(response);
        this.processError(response.error);
        this.loading = false;
        return response.success;
    }

    processError(error?: string) {
    }
}

export default UpdateAgencyBillingClosureValuesStore;